export default "__VITE_ASSET__35497506__"